// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:errors` (see frontend/package.json).
// Source: agent.shared.types.repository.ConflictMarkersError

import { RpcError, registerRpcError } from "@/app_store/rpc_error";

// Wire shape of this error: `code` discriminates the type, `message` is the
// human-readable text, and the remaining keys are the exception's own fields.
export interface ConflictMarkersErrorData {
    code: "ConflictMarkersError";
    message: string;
    files: string[];
}

export class ConflictMarkersError extends RpcError {
    readonly code = "ConflictMarkersError" as const;
    readonly files: string[];

    constructor(data: ConflictMarkersErrorData) {
        super(data.code, data.message, data);
        this.files = data.files;
    }
}

registerRpcError("ConflictMarkersError", ConflictMarkersError);
